import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUploadLoader = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={62} height={62} fill='none' {...props}>
    <g>
      <animateTransform
        attributeName='transform'
        attributeType='XML'
        dur='1.5s'
        from='0 31 31'
        repeatCount='indefinite'
        to='360 31 31'
        type='rotate'
      />
      <path
        stroke='#9575CD'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2.851}
        d='M31.189 5.374v10.135M31.189 45.914V56.05M13.275 12.798l7.17 7.17M41.932 41.455l7.171 7.17M5.851 30.712h10.135M46.392 30.712h10.135M13.275 48.626l7.17-7.171M41.932 19.968l7.171-7.17'
      />
    </g>
  </svg>
);
export default SvgUploadLoader;
